import React, {useMemo, useState} from 'react';
import {getClassList} from "../../../../Utility/siteConfig";
import CatchErrors from "../../../../Utility/CatchErrors";
import ItemClusterImages from "../image_display/ItemClusterImages";
import ItemClusterMain from "./ItemClusterMain";
import ClusterAddToCart from "../cart_display/ClusterAddToCart";
import {camelizeKeysDeep} from "../../../../ReduxStore/Helpers/transformObject";

/**
 * 2025-10 ClusterAddToCart and below modernized, all tailwind, props fully camelized.
 *
 * @param props
 * @returns {JSX.Element}
 * @constructor
 */
export default function ItemClusterUi(props) {
  // , products, itemCache, cartItem, sectionConfig, productAttributes
  const {cluster, clusterState, shoppingCart, cartItem, products, selectedItem, itemCache} = props;

  const camelizedProducts = useMemo(
   () => camelizeKeysDeep(products), [products]
  );

  const className = getClassList({
    key: 'ItemCluster',
    base: [
      'item-cluster lg:grid lg:grid-cols-12 py-8',
      clusterState.highlighted ? 'item-cluster-highlighted' : null,
    ],
    fallback: ""
  });
  // FIXME: css classes item-cluster item-cluster-highlighted

  // cluster.id like front_row_neosupreme_seat_covers
  return <div className={className} id={"item-cluster-" + cluster.id}>
    <div className="lg:col-span-4 min-h-4 ">
      <CatchErrors><ItemClusterImages
        product={selectedItem?.product}
        products={products}
        itemCache={itemCache}
        clusterState={clusterState}
      /></CatchErrors>
    </div>
    <div className="lg:col-span-5 min-h-4 lg:px-4">
      <CatchErrors><ItemClusterMain {...props} /></CatchErrors>
    </div>
    <div className="lg:col-span-3 min-h-4">
      <CatchErrors><ClusterAddToCart
        clusterState={clusterState}
        products={camelizedProducts}
        shoppingCart={shoppingCart}
        cartItem={cartItem}
        /></CatchErrors>
    </div>
  </div>

}



